import { render, staticRenderFns } from "./AndroidLogoIcon.vue?vue&type=template&id=1b475b23"
import script from "./AndroidLogoIcon.vue?vue&type=script&lang=js"
export * from "./AndroidLogoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports